module.exports = __webpack_public_path__ + "assets/images/zoom_out.d54296a69a8efa1303150d2adf2c6942.svg";